define('modules/start/products/base/logobutton/view',['require','exports','module','env','views/BaseView','ldsh!./template'],function (require, exports, module) {
  "use strict";

  var Config = require("env");
  var BaseView = require("views/BaseView");

  var Layout = BaseView.extend({
    template: require("ldsh!./template"),

    events: {
      "click .redirect-btn": "redirect",
      "click .activate-btn": "activateAction",
    },

    serialize: function () {
      return {
        active: this.active,
        logoName: this.logoName,
      };
    },

    redirect: function () {
      //https://app.test.mdirector.com/login?dashboard=true&company=43448
      var url = this.privateUrl + "&company=" + this.companyId;
      window.location = url;
    },

    activateAction: function () {
      if (this.companyId === null) {
        var firstCompany = this.products.getFirstCompanyFromService(
          this.product.get("name")
        );
        this.companyId = firstCompany.id;
      }

      if (this.activeinAnyCompany || this.product.wasAlreadyActivated()) {
        this.goToStatusAccount();
      } else {
        this.createAccount();
      }
    },

    createAccount: function () {
      var url = "/activation/service/" + this.serviceName;
      url += "/company/" + this.companyId;
      window.location = url;
    },

    goToStatusAccount: function () {
      var url = "/accounts";
      url += "/company/" + this.companyId;
      url += "/group/" + this.groupId;
      window.location = url;
    },
  });

  module.exports = Layout;
});

